import { Component, Input } from '@angular/core';

@Component({
  selector: 'track-lead-card-bottom-chip',
  templateUrl: './track-lead-card-bottom-chip.component.html',
  styleUrls: ['./track-lead-card-bottom-chip.component.scss'],
})
export class TrackLeadCardBottomChipComponent {
  @Input() value?: string;
  @Input() width: string = '70px';
  @Input() truncate: boolean = false;
  @Input() borderColor?: string;
  @Input() businessLine: string = '';

  getBackgroundColor(): string {
    if (this.businessLine) {
      switch (this.businessLine) {
        case 'POR DEFINIR':
          return 'bg-neutrals-200';
        case 'CONCRETO':
          return 'bg-bgConcreto';
        case 'VIGUETAS':
          return 'bg-bgViguetas';
        case 'BLOQUES':
          return 'bg-bgBloques';
        case 'EMBOLSADO':
          return 'bg-bgEmbolsado';
        default:
          return 'bg-neutrals-100';
      }
    }
    return 'bg-neutrals-100';
  }
}
